import { useState } from 'react';
import { MOBILE_PLACEHOLDER } from '@/components/mobile_preview/constants';
import { useMobilePreview } from '@/components/mobile_preview/mobilePreviewContext';
import type { BannerSize } from '@/api/generated/schemas';
import { CORNER_RADIUS, RATIO } from './creative';

interface CreativeSlotProps {
  imageUrl: string | null | undefined;
  alt: string;
  /** Container ratio. The creative is cropped to it, as on the phone. */
  size: BannerSize;
}

/**
 * One banner-shaped container with a creative cropped into it — the
 * unit both the carousel and the single-creative preview are made of,
 * so the two cannot drift apart on radius, ratio or crop behaviour.
 */
export const CreativeSlot = ({ imageUrl, alt, size }: CreativeSlotProps) => {
  const { mobileTheme } = useMobilePreview();
  // A creative that 404s keeps the placeholder, exactly as the app does.
  const [failed, setFailed] = useState(false);

  return (
    <div
      style={{
        aspectRatio: `${RATIO[size].w} / ${RATIO[size].h}`,
        borderRadius: CORNER_RADIUS,
        overflow: 'hidden',
        background: MOBILE_PLACEHOLDER[mobileTheme],
      }}
    >
      {imageUrl && !failed && (
        <img
          src={imageUrl}
          alt={alt}
          draggable={false}
          onError={() => setFailed(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      )}
    </div>
  );
};
